import { readable } from 'svelte/store';
export class DefinedMessageService {
    constructor(definedMessageRemoteRepository, contextId) {
        this.definedMessageRemoteRepository = definedMessageRemoteRepository;
        this.contextId = contextId;
        this.definedMessagesPromise = null;
    }
    async getOfType(type) {
        if (this.definedMessagesPromise === null) {
            this.definedMessagesPromise = this.definedMessageRemoteRepository.fetchAll();
        }
        return (await this.definedMessagesPromise).filter(definedMessage => definedMessage.type === type);
    }
    async getPrimaryOfType(type) {
        const primaryMessage = await this.getPrimaryOfTypeOrNull(type);
        if (primaryMessage === null) {
            throw new Error(`No defined message for type ${type}`);
        }
        return primaryMessage;
    }
    async getPrimaryOfTypeOrNull(type) {
        const definedMessages = await this.getOfType(type);
        if (definedMessages.length === 0) {
            return null;
        }
        return definedMessages[0];
    }
    async save(definedMessage) {
        if (definedMessage.contextId !== this.contextId) {
            throw 'Cannot edit message of other context';
        }
        await this.definedMessageRemoteRepository.save(definedMessage);
        this.definedMessagesPromise = null;
    }
    async remove(definedMessage) {
        await this.definedMessageRemoteRepository.remove(definedMessage);
        this.definedMessagesPromise = null;
    }
    async reorder(definedMessages) {
        await this.definedMessageRemoteRepository.reorder(definedMessages.map(m => m.id));
        this.definedMessagesPromise = null;
    }
    async moveUp(definedMessage, definedMessages) {
        const index = definedMessages.indexOf(definedMessage);
        if (index <= 0) {
            return definedMessages;
        }
        const reordered = [...definedMessages];
        reordered.splice(index - 1, 2, reordered[index], reordered[index - 1]);
        await this.reorder(reordered);
        return reordered;
    }
    async moveDown(definedMessage, definedMessages) {
        const index = definedMessages.indexOf(definedMessage);
        if (index < 0 || index >= definedMessages.length - 1) {
            return definedMessages;
        }
        const reordered = [...definedMessages];
        reordered.splice(index, 2, reordered[index + 1], reordered[index]);
        await this.reorder(reordered);
        return reordered;
    }
    createStoreForPrimary(type) {
        return readable('', set => {
            this.getPrimaryOfType(type)
                .then(definedMessage => set(definedMessage.text));
        });
    }
}
